import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Popup from 'reactjs-popup';
import { useWindowSize } from '../Common/CommonHooks';

const LoginErrorPopup = ({errorType, handleClickCancel, setShowErrorPopup}) => {
    const { t, i18n } = useTranslation();

    const { isMobileSize } = useWindowSize();
    let mobileStyle = isMobileSize ? 'is-mobile' : 'is-desktop';
    useEffect(() => {
        if (isMobileSize) {
            mobileStyle = 'is-mobile'
        } else {
            mobileStyle = 'is-desktop';
        }
    }, [isMobileSize]);

    let errorTitle = t('LS_BS_ERRORPOPUP_BUSY_TITLE');
    let errorMessage = t('LS_BS_ERRORPOPUP_BUSY_MESSAGE');
    if (errorType === 'session timeout') {
        errorTitle = t('LS_BS_ERRORPOPUP_TIMEOUT_TITLE');
        errorMessage = t('LS_BS_ERRORPOPUP_TIMEOUT_MESSAGE');
    }
    if(errorType === 'exception') {
        errorTitle = t('LS_BS_ERRORPOPUP_BUSY_TITLE');
        errorMessage = t('LS_BS_LOGIN_ERROR_CIAM_ERROR');
    }

    const handleClickClose = () => {
        // only close the popup if error occurs when trusting browser
        if (errorType === 'trust browser failure') {
            setShowErrorPopup(false);
        }
        handleClickCancel();
        //setShowErrorPopup(false)
    }
    const handleUnclockClick=()=>{
        window.open(window.globalConfig.WCIP_URL+`${i18n.language=='en'?"/en-us/forgot?EP=BS":"/zh-hk/forgot?EP=BS"}`,"_blank")
    }
    return (
        <Popup open={true} closeOnDocumentClick={false} className={`errorpopup ${mobileStyle}`} onClose={handleClickClose}>
            <div className="errorpopup-container">
                <div className="errorpopup-title">{t('LB_BS_LOGIN_CIAM_LOCKED')}</div>
                <div className="errorpopup-message">{t('LB_BS_LOGIN_CIAM_LOCKED2')}</div>
                <div className={`button-box loginerrorpopup-btn-grp`}>
                    <div className='row2'>
                        <div className="errorpopup-close" onClick={handleClickClose}>{t('LB_OTP_CANCEL')}</div>
                        <div className="errorpopup-unlock cta_yellow" onClick={handleUnclockClick}>{t('LB_BS_LOGIN_CIAM_UNLOCK')}</div>
                    </div>
                </div>
            </div>
        </Popup>
    )
}

export default LoginErrorPopup;